var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: "64px",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    width: "64px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "   M10,41.3v12c0,1.1,0.9,2,2,2h40c1.1,0,2-0.9,2-2v-12H10z",
    fill: "none",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "   M42.6,19.4c3.8,7.3,7.6,14.7,11.4,22c-14.7,0-29.3,0-44,0c3.8-7.3,7.6-14.7,11.4-22",
    fill: "none",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 32,
    x2: 32,
    y1: 8.7,
    y2: 28.2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 32,
    x2: 35.7,
    y1: 8.7,
    y2: 12.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 28,
    x2: 31.7,
    y1: 12.4,
    y2: 8.7
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 47.3,
    cy: 46.7,
    fill: "none",
    r: 2.3,
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 21.4,
    x2: 27.5,
    y1: 19.4,
    y2: 19.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 36.4,
    x2: 42.5,
    y1: 19.4,
    y2: 19.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 21.9,
    x2: 41.9,
    y1: 36.4,
    y2: 36.4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 23.5,
    x2: 40.2,
    y1: 32.1,
    y2: 32.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.469126df4127e870c21611e576b85d00.svg";
export { ForwardRef as ReactComponent };